import { render, staticRenderFns } from "./DetailReturKirimInven.vue?vue&type=template&id=485b269a&"
import script from "./DetailReturKirimInven.vue?vue&type=script&lang=js&"
export * from "./DetailReturKirimInven.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports